export let mentionsMeFilter = "LUmzrb";
export default {mentionsMeFilter};